module.exports = __webpack_public_path__ + "static/media/opensans-light.ecf98d5b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-light.woff
// module id = 292
// module chunks = 0